import React from 'react';

export class CustomInputFilter extends React.Component {
  constructor(props) {
      super(props);
      this.inputField = React.createRef();
  }

  filter = (e) => {
      if (this.props.changeFilterOptions) {
          this.props.changeFilterOptions(e.target.name, e.target.value)
      }
  }

  deleteText = () => {
      this.inputField.current.value = ''
      if(this.props.changeFilterOptions){
          this.props.changeFilterOptions(this.inputField.current.name, '')
      }
  }

  blur = () => {
      if (this.props.blur) {
          setTimeout(()=>{
              this.props.blur();
          })
      }
  }

  focus = () => {
      if (this.props.focus) {
          this.props.focus(this.props.input_name);
          this.inputField.current.focus();
      }
  }

  render() {
      if (this.props.type === 'select') {
          return (
              <div className="status-select" key={this.props.input_name}>
                  <select
                      className="form-control"
                      name={this.props.input_name}
                      onChange={this.filter}
                      defaultValue={this.props.defaultValue ? this.props.defaultValue : this.props.placeholder}>
                      <option label={this.props.placeholder} value={''}>{this.props.placeholder}</option>
                      {
                          Object.values(this.props.statuses).map((status, index) => (
                              <option label={status} value={status} key={index}>{status}</option>
                          ))
                      }
                  </select>
              </div>
          )
      }
      return (
          <div key={this.props.input_name} className={`field-block ${this.props.type === 'date' ? 'date-field': ''} ${this.props.focused && this.props.activeClassName ? this.props.activeClassName : ''}`}>
              <input className={`filter text-filter form-control ${this.props.inputClass || ' '}`}
                     autoComplete="off"
                     name={this.props.input_name}
                     ref={this.inputField}
                     type={this.props.type ? this.props.type : "text"}
                     onChange={this.filter}
                     onFocus={this.focus}
                     onBlur={this.blur}
                     defaultValue={this.props.defaultValue}
                     placeholder={this.props.placeholder}/>
              { this.props.focused ?
                  <span className="kr kr-close" onClick={this.deleteText} />
                  : <span className="kr kr-search" onClick={this.focus} />
              }
          </div>
      );
  }
}

export function getCustomFilter(unUsedFilter, customFilterParameters) {
  return <CustomInputFilter { ...customFilterParameters } />;
}


// WEBPACK FOOTER //
// ./src/components/CustomInput/index.js